var spell = require('./spell-dict-jian.json');

var stroke = require('./stroke-count-jian.json');

module.exports = {
  spell: spell,
  stroke: stroke
};